export { DepositBanner } from './DepositBanner'
export type {
  DepositBannerProps,
  DepositBannerTranslations,
} from './DepositBanner'
